/* eslint-disable no-undefined */
import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from 'assets/logo-white.png';
import {isTablet, isIPad13, isIOS, isMacOs, getUA} from 'react-device-detect';
import Gif from 'assets/rotation-from-horizontal-to-vertical.gif';
import {begin} from 'utils/beforeunload';
import strings from 'utils/strings';
import Introduksjon from 'components/Introduksjon';
import Orddiktat from 'components/Orddiktat';
import Ordkjedetesten from 'components/Ordkjedetesten';
import Tulleordtesten from 'components/Tulleordtesten';
import SprakForstaelse from 'components/SprakForstaelse';
import Skrivehastighet from 'components/Skrivehastighet';
import Leseproven from 'components/Leseproven';
import Ordforstaelse from 'components/Ordforstaelse';
import Ferdig from 'components/Ferdig';
import getTestInfo from 'api/getTestInfo';
import getUserInfo from 'api/getUserInfo';
import upsertTestInfo from 'api/upsertTestInfo';
import {setTestCandidateGrade} from 'actions/index';

const testSteps = [
	Introduksjon,
	Tulleordtesten,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Leseproven,
	Orddiktat,
	Ferdig,
];
const testStepsWithoutReading = [
	Introduksjon,
	Tulleordtesten,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Orddiktat,
	Ferdig,
];

const testStepsNorming = [
	Introduksjon,
	Tulleordtesten,
	SprakForstaelse,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Leseproven,
	Orddiktat,
	Ferdig,
];

class ScreeningTest extends React.Component {
	
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			isNorming:false,
			needLanguageSetting: false,
			isPortrait: true,
			isRotateDeviceFirstTimeRendered: true,
		};
		this.handleResize = this.handleResize.bind(this);

		this.renderRemainingTests = [];
	}

componentDidMount() {
  this.handleResize();
  window.addEventListener('resize', this.handleResize);
  this.initializeTestFlow();
}

	componentWillUnmount() {
		window.addEventListener('resize', this.handleResize);
	}

	// eslint-disable-next-line complexity
	initializeTestFlow = async () => {
  try {
    const testInfo = await getTestInfo();
    if (!testInfo) {
      console.warn('No test info received');
      return;
    }

    var exclusiveTests = (testInfo && testInfo.exclusiveTests) ? testInfo.exclusiveTests : {};
    var excludeReading = Boolean(testInfo && testInfo.excludeReading);
    var isNorming = Boolean(testInfo && testInfo.isNorming);

    var rawGrade = testInfo ? testInfo.grade : undefined;
    var grade = (rawGrade !== null && rawGrade !== undefined) ? Number(rawGrade) : NaN;
    if (!Number.isNaN(grade)) {
      this.props.onSetTestCandidateGrade(grade);
    }

    var testToContinue = Object.values(exclusiveTests);
    if (testToContinue && testToContinue.length) {
      var continueCodes = new Set(
        testToContinue
          .map(function (v) { return Number(v); })
          .filter(function (n) { return Number.isFinite(n); })
      );

      var ordered = [];
      ordered.push({ code: 3, Comp: Tulleordtesten });
      if (isNorming) { ordered.push({ code: 7, Comp: SprakForstaelse }); }
      ordered.push({ code: 2, Comp: Ordkjedetesten });
      ordered.push({ code: 4, Comp: Skrivehastighet });
      ordered.push({ code: 6, Comp: Ordforstaelse });
      if (!excludeReading) { ordered.push({ code: 5, Comp: Leseproven }); }
      ordered.push({ code: 1, Comp: Orddiktat });

      this.renderRemainingTests = ordered
        .filter(function (step) { return continueCodes.has(step.code); })
        .map(function (step) { return step.Comp; });

      if (this.renderRemainingTests.length) {
        this.renderRemainingTests.push(Ferdig);
        this.setState({ needLanguageSetting: true, isNorming: isNorming });
      }
    }

	if (isNorming && !this.state.deviceInfoSaved) {
				try {
					var ua = '';
					if (typeof getUA === 'string' && getUA) {
						ua = getUA;
					} else if (
						typeof navigator !== 'undefined' &&
						navigator.userAgent
					) {
						ua = navigator.userAgent;
					}

					var hasNavigator = typeof navigator !== 'undefined';
					var maxTouchPoints =
						hasNavigator &&
						typeof navigator.maxTouchPoints === 'number'
							? navigator.maxTouchPoints
							: 0;

					var isLikelyIPad =
						(isMacOs && maxTouchPoints > 1) ||
						/iPad/i.test(ua) ||
						Boolean(isIPad13) ||
						(isIOS && isTablet);

					var isLikelyTablet =
						Boolean(isTablet) ||
						/iPad/i.test(ua) ||
						(isMacOs && maxTouchPoints > 1);
					await upsertTestInfo({
						testDevice: isLikelyIPad ? 'ipad' : 'non-ipad',
						isTablet: Boolean(isLikelyTablet),
					});
					this.setState({deviceInfoSaved: true});
				} catch (e) {
					console.warn('Device info upsert failed:', e);
				}
			}

    var response = await getUserInfo();
    if (response && response.ok) {
      this.setState({
        isNorming: isNorming,
        isLoggedIn: true,
        excludeReading: excludeReading,
      });
      begin();
    } else {
      window.location.href = '/';
    }
  } catch (err) {
    console.error('Error initializing test flow:', err);
  }
};

	handleResize = () => {
		if (window.innerHeight > window.innerWidth) {
			this.setState({
				isPortrait: true,
			});
		} else {
			this.setState({
				isPortrait: false,
			});
		}
	};

	onSelectLanguage(lang) {
		strings.setLanguage(lang);
		this.setState({
			needLanguageSetting: false,
		});
	}
	render() {
		const {isLoggedIn, isPortrait, isRotateDeviceFirstTimeRendered} =
			this.state;

		if (!isLoggedIn) {
			return null;
		}

		const {currentStepIndex} = this.props;

		if (this.renderRemainingTests.length) {
			var CurrentStep = this.renderRemainingTests[currentStepIndex];
		}
		else if(this.state.isNorming) {
		
			var CurrentStep = testStepsNorming[currentStepIndex];
		}
		else if(this.state.excludeReading) {
			var CurrentStep = testStepsWithoutReading[currentStepIndex];
		}
		else {
			var CurrentStep = testSteps[currentStepIndex];
		}
		if (!isPortrait && isRotateDeviceFirstTimeRendered) {
			setTimeout(() => {
				this.setState({isRotateDeviceFirstTimeRendered: false});
			}, 3000);
		}
		return (
			<div>
				<header className="lit-header">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate logo"
						/>
					</h1>
				</header>
				{Boolean(this.renderRemainingTests.length) &&
					this.state.needLanguageSetting && (
						<div className="lit-test-intro">
							<h1>{`Velg/vel språk`}</h1>

							<button
								className="lit-test-intro-language-button"
								tabIndex="1"
								onClick={() => this.onSelectLanguage('no')}
							>
								{`Norsk Bokmål`}
							</button>
							<button
								className="lit-test-intro-language-button"
								tabIndex="2"
								onClick={() => this.onSelectLanguage('nn')}
							>
								{`Norsk Nynorsk`}
							</button>
						</div>
					)}
				{isRotateDeviceFirstTimeRendered && !isPortrait && isTablet && (
					<div className="lit-test-rotation-gif">
						<img src={Gif} alt="rotate tablet gif" />
					</div>
				)}
				{!this.state.needLanguageSetting && (
					<div className="lit-wrapper--article text-center">
						<CurrentStep isNorming={this.state.isNorming} />
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
